import api from '@/api';

class PropertyContact {
  /**
   * @returns {AxiosPromise<any>}
   */
  static find(propertyContactId) {
    return api.get(`/contacts/${propertyContactId}`);
  }

  /**
   * Index / Get listing of contacts
   * @returns {*}
   */
  static list() {
    return api.get(`/contacts/`);
  }

  /**
   * Add a property contact
   * @param params
   * @returns {*}
   */
  static add(params) {
    return api.post('/contacts', params);
  }

  /**
   * Update a property contact
   * @param propertyContactId
   * @param params
   * @returns {*}
   */
  static update(params) {
    const propertyContactId = params.propertyContactId;
    return api.put(`/contacts/${propertyContactId}`, params);
  }

  /**
   * Delete a property file
   * @returns {*}
   */
  static delete(propertyId) {
    return api.delete(`/contacts/${propertyId}`);
  }
}

export default PropertyContact;
